import { LeagueTableUserEvents } from "~/modules/analytics/events/leagueTable";
import { getManagerURL } from "~/routes";
import { getAssetClassLinkMetadata } from "~/utils/getAssetClassLinkMetadata";
import type {
    PerformanceByPeriod,
    PerformanceGroup,
    PerformancePeriod,
} from "~/modules/asset_classes/performance-types";

export interface ReturnRow {
    analyticsLabel: string | null;
    color: string;
    href: string | null;
    id: number;
    name: string;
    oneMonth: number | null;
    threeMonth: number | null;
    yearToDate: number | null;
    oneYear: number | null;
}

/** Table values are the endpoints of the same series used by each period tab. */
export function getReturnRows(
    performanceByPeriod: PerformanceByPeriod,
    period: PerformancePeriod,
    group: PerformanceGroup,
    managerSlugs: Record<number, string> | null = null,
): ReturnRow[] {
    function getReturn(id: number, period: PerformancePeriod): number | null {
        const series = performanceByPeriod[period].series.find(
            (item) => item.id === id,
        );
        return series?.returnPercent ?? null;
    }

    return performanceByPeriod[period].series.map((series) => {
        const managerSlug = managerSlugs?.[series.id];
        return {
            analyticsLabel:
                group === "assetClass"
                    ? LeagueTableUserEvents.leagueTableAssetClassLinkClick
                    : managerSlug
                      ? LeagueTableUserEvents.leagueTableManagerLinkClick
                      : null,
            color: series.color,
            href:
                group === "assetClass"
                    ? getAssetClassLinkMetadata(series.id).href
                    : managerSlug
                      ? getManagerURL({ managerSlug })
                      : null,
            id: series.id,
            name: series.name,
            oneMonth: getReturn(series.id, "1M"),
            threeMonth: getReturn(series.id, "3M"),
            yearToDate: getReturn(series.id, "YTD"),
            oneYear: getReturn(series.id, "1Y"),
        };
    });
}
